export const lower = (item: string) => item.toLowerCase();
